/**
 * Phonics Letter Qq — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/qq/）
 *
 * Step 1: Song/Chant — qq.mp4, 00:11~01:36
 * Step 2: 4格单词 — quiz/queen/quilt/quarter
 * Step 3: Learn the Story (1) — 左上视频 + 右上3单词(time/quiz time/quick) + 下部3句故事
 * Step 4: Learn the Story (2) — 上面视频下面文字，不要翻译
 * Step 5: Learn the Story (3) — 上面视频下面文字，不要翻译
 */

const MEDIA_BASE = '/media/phonics/qq';
const V = 'v1';

export const letterDataQq = {
  letter: 'Qq',
  title: 'Phonics',
  subtitle: 'Letter Qq',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Qq.mp4?${V}`,
    poster: `${MEDIA_BASE}/Qq.png?${V}`,
    startTime: 11,
    endTime: 96,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  // 统一 storySections
  storySections: [

    // Learn the Story (1) — 左上视频 + 右上单词 + 下部3句故事
    // splitAt=3: 前3条 = 右侧单词(time/quiz time/quick)，剩余 = 下部故事句
    {
      label: 'Learn the Story (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_story_queen.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 3,
      lines: [
        // 右侧单词（去掉音标）
        { en: 'time', cn: '时间', audioEn: `${MEDIA_BASE}/w_en_time.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_time.mp3?${V}` },
        { en: 'quiz time', cn: '竞猜时间', audioEn: `${MEDIA_BASE}/w_en_quiz_time.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_quiz_time.mp3?${V}` },
        { en: 'quick', cn: '快', audioEn: `${MEDIA_BASE}/w_en_quick.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_quick.mp3?${V}` },
        // 下部故事句（有翻译）
        { en: "Who is this?", cn: '这是谁？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: "It's a queen.", cn: '这是一个女王。', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Yes! Good job!', cn: '是的！做得好！', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Learn the Story (2) — 上面视频下面文字，不要翻译
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_quilt.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'What is this?', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}` },
        { en: "It's a quilt.", audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}` },
        { en: 'Yes! Good job!', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}` },
      ],
    },

    // Learn the Story (3) — 上面视频下面文字，不要翻译
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_quarter.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'What is this?', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}` },
        { en: "It's a quarter.", audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}` },
        { en: 'Yes! You won the quiz!', audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（来自 AtoZ_cover/Qq.png）
  coverPoster: `${MEDIA_BASE}/Qq.png?${V}`,
};

export default letterDataQq;
